import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';

const LANGS = [
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' }, // England/UK flag
];

function updateUrlQueryParam(lang) {
  const url = new URL(window.location.href);
  url.searchParams.set('lng', lang);
  window.history.replaceState({}, '', url.toString());
}

export default function LanguageSwitcher() {
  const { i18n: i18nextInstance } = useTranslation();

  const [language, setLanguage] = React.useState(
    LANGS.some((l) => l.code === i18nextInstance.language)
      ? i18nextInstance.language
      : 'tr',
  );

  // Sync with i18n language changes
  React.useEffect(() => {
    const currentLang = i18nextInstance.language;
    if (LANGS.some((l) => l.code === currentLang) && currentLang !== language) {
      setLanguage(currentLang);
    }
  }, [i18nextInstance.language, language]);

  const handleChange = (event) => {
    const newLang = event.target.value;
    if (!newLang || newLang === language) return;

    setLanguage(newLang);
    i18n.changeLanguage(newLang);
    updateUrlQueryParam(newLang);
  };

  const current = LANGS.find((l) => l.code === language) || LANGS[0];

  return (
    <FormControl
      variant="standard"
      sx={{ minWidth: 80, color: 'white' }}
    >
      <Select
        value={language}
        onChange={handleChange}
        disableUnderline
        renderValue={() => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'white' }}>
            <Box component="img" sx={{ width: 20 }} src={`/country/${current.code}.svg`} alt={current.label} />
            <Typography variant="body2">
              {current.code.toUpperCase()}
            </Typography>
          </Box>
        )}
      >
        {LANGS.map((lang) => (
          <MenuItem
            key={lang.code}
            value={lang.code}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box component="img" sx={{ width: 16 }} src={`/country/${lang.code}.svg`} alt={lang.label} />
              <Typography variant="body2">{lang.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
